const watermark = {};
const setWatermark = (str) => {
  const id = 'watermark';

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id));
  }

  const can = document.createElement('canvas');
  can.width = 350;
  can.height = 150;
  const cans = can.getContext('2d');
  // eslint-disable-next-line no-mixed-operators
  cans.rotate(-15 * Math.PI / 300);
  cans.font = '25px Vedana';
  cans.fillStyle = '#374566';
  cans.opacity = 0.1;
  cans.textAlign = 'left';
  cans.textBaseline = 'Middle';
  cans.fillText(str, can.width / 8, can.height / 2);

  const div = document.createElement('div');
  div.id = id;
  div.style.pointerEvents = 'none';
  div.style.top = '60px';
  div.style.left = '180px';
  div.style.right = '0';
  div.style.position = 'fixed';
  div.style.zIndex = '999999';
  div.style.opacity = '0.1';
  div.style.width = `${document.documentElement.clientWidth}px`;
  div.style.height = `${document.documentElement.clientHeight}px`;
  div.style.background = `url(${can.toDataURL('image/png')}) left top repeat`;
  document.body.appendChild(div);
  return id;
};

// 该方法只允许调用一次
watermark.set = (str) => {
  let id = setWatermark(str);
  if (document.getElementById(id) === null) {
    id = setWatermark(str);
  }
  window.onresize = () => {
    setWatermark(str);
  };
};
export default watermark;



//////////////////
// WEBPACK FOOTER
// ./static/plugins/watermark/watermark.js
// module id = null
// module chunks = 